import React from 'react';
import { BrowserRouter } from 'react-router-dom';

type TRouterProps = {
  children: React.ReactNode;
};

export const Router = ({ children }: TRouterProps) => (
  <BrowserRouter>{children}</BrowserRouter>
);
